// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions";
// import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage"; // Starter Custom Code
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import ProductListProductImage, {
    ProductListProductImageStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { productCardProps } from "@store/Themes/common/props/productCard";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

/* Store Custom Code */
import { useIsCommerceWebsite } from "@store/Framework/Store/Context/ContextHooks";
/* Store Custom Code */

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    // Starter Custom Code
    productListProductImage?: ProductListProductImageStyles;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: productCardProps.card,
    imageWrapper: productCardProps.image?.wrapper,
    sponsoredText: mergeProps<ProductListProductGridCardStyles["sponsoredText"]>(productCardProps.sponsoredText, {
        css: css`
            border-left: 0;
        `,
    }),
    productListProductImage: {
        compareCheckbox: {
            mergeCss: true,
            css: css`
                margin-bottom: ${pxToRem(-4)};
            `,
        },
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}) => {
    const isCommerceWebsite = useIsCommerceWebsite(); // Store Custom Code

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            {showImage /* Starter Custom Code */ ? (
                <StyledWrapper {...styles.imageWrapper}>
                    {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                    {/* Store Custom Code - Start */}
                    <ProductListProductImage
                        showImage={showImage}
                        showCompare={showCompare && isCommerceWebsite}
                        showImageBadge={showImageBadges}
                        showTextBadge={showTextBadges}
                    />
                    {/* Store Custom Code - End */}
                </StyledWrapper>
            ) : null}
            <ProductListProductInformation
                showAttributes={showAttributes}
                /* Store Custom Code - Start */
                showAvailability={showAvailability && isCommerceWebsite}
                /* Store Custom Code - End */
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            />
            {/* Store Custom Code - Start */}
            {isCommerceWebsite && <ProductListActions showAddToList={showAddToList} showPrice={showPrice} />}
            {/* Store Custom Code - End */}
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
